"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ComponentException = _interopRequireDefault(require("@ikea-aoa/ikea-shared-utils/lib/exception/ComponentException"));

var _StringUtility = _interopRequireDefault(require("@ikea-aoa/ikea-shared-utils/lib/util/StringUtility"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Handles information about a supported prop.
 */
var SupportedProp = /*#__PURE__*/function () {
  /**
   * Class constructor.
   *
   * @param {string} name Name of the prop.
   * @param {string} type Type of the prop.
   * @param {boolean} [isRequired] TRUE if required. Default is FALSE.
   * @param {string[]|null} [validValues] Array of valid values.
   * @param {string|boolean|number|null} [defaultValue] Default value.
   */
  function SupportedProp(name, type) {
    var isRequired = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var validValues = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var defaultValue = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

    _classCallCheck(this, SupportedProp);

    this.name = name;
    this.attributeName = 'data-' + _StringUtility.default.camelToKebabCase(name);
    this.type = type;
    this.isRequired = isRequired;
    this.validValues = validValues || [];
    this.defaultValue = defaultValue;
  }
  /**
   * Parses a prop value.
   *
   * @throws ComponentException
   * @param {string} value The prop value.
   * @returns {string|number|object|boolean} Parsed prop value.
   */


  _createClass(SupportedProp, [{
    key: "parseValue",
    value: function parseValue(value) {
      var parsedValue = undefined;

      switch (this.type) {
        case 'string':
          parsedValue = value;
          break;

        case 'number':
          parsedValue = parseFloat(value);

          if (isNaN(value)) {
            throw new _ComponentException.default('Failed to parse prop with name "' + this.name + '". The value "' + value + '" was not a valid number.');
          }

          break;

        case 'object':
          if (value) {
            try {
              parsedValue = JSON.parse(value);
            } catch (error) {
              throw new _ComponentException.default('Failed to parse prop with name "' + this.name + '". The value "' + value + '" was not a valid object. Error: ' + error.toString());
            }
          } else {
            parsedValue = null;
          }

          break;

        case 'boolean':
          parsedValue = typeof value === 'string' ? value === 'true' : value === true;
          break;
      }

      if (parsedValue === undefined) {
        throw new _ComponentException.default('Failed to parse prop with name "' + this.name + '". The type "' + this.type + '" is not valid.');
      }

      return parsedValue;
    }
  }]);

  return SupportedProp;
}();

exports.default = SupportedProp;